import { Grid } from '@prometheus/components';

import React, { FC, useContext, useEffect, useMemo } from 'react';
import { SearchInModulesComponent } from './SearchInModulesComponent';
import { resetBreadcrumbs } from '@prometheus/redux';
import { useDispatch } from 'react-redux';

export const Welcome: FC<any> = props => {
  const { modulesSideNavigation: list, enabledModuleIds } = props;
  const dispatch = useDispatch();
  const IS_ADMIN = useMemo(
    () => enabledModuleIds.includes('admin'),
    [enabledModuleIds]
  );

  useEffect(() => {
    dispatch(resetBreadcrumbs());
    document.title = `Prometheus`;
  }, []);

  const modules = useMemo(() => {
    const hashMap: any = {};
    list.forEach((elem: any) => {
      hashMap[elem.name] = elem;
    });

    return hashMap;
  }, []);

  if (!modules) {
    return <></>;
  }
  return (
    <Grid
      container
      sx={{
        backgroundColor: 'backgroundColor.dark',
        minHeight: 'calc(100vh - 60px)',
        height: '100%',
        alignContent: 'flex-start',
        '.content-block': {
          transition: 'transform 300ms',
        },
        '.content-block:hover': {
          transform: 'scale(1.01)',
          transition: 'transform 300ms',
        },
      }}
    >
      <Grid
        item
        xs={12}
        container
        justifyContent="space-around"
        sx={{
          backgroundColor: '#24314d',
          backgroundImage: 'url("/torch.svg")',
          backgroundRepeat: 'no-repeat',
          height: 240,
          backgroundSize: { xs: 260, md: '280px' },
          backgroundPositionY: '-20px',
          backgroundPositionX: {
            xs: 'calc(5% - 130px)',
            md: 'calc(15% - 130px)',
            lg: 'calc(20% - 120px)',
            xl: 'calc(27% - 120px)',
          },
        }}
      >
        <Grid
          item
          xs={12}
          color="#ffffff"
          fontSize={{ xs: 50, md: 60, lg: 70 }}
          display="flex"
          justifyContent="flex-start"
          ml={{
            xs: 'calc(5% + 130px)',
            md: 'calc(15% + 130px)',
            lg: 'calc(20% + 110px)',
            xl: 'calc(27% + 110px)',
          }}
          alignItems="end"
          paddingBottom={{ xs: 2, lg: 1 }}
          fontFamily={"'Rosario', sans-serif"}
          fontWeight={700}
        >
          <span>Prometheus</span>
        </Grid>
        <Grid
          item
          xs={10}
          md={7}
          lg={6}
          xl={5}
          display="flex"
          justifyContent="center"
          minWidth={540}
        >
          <SearchInModulesComponent />
        </Grid>
      </Grid>

      <Grid container px={{ xs: 4, lg: 8, xl: 10 }} py={4} spacing={2}>
        <Grid item xs={12} md={6}>
          <modules.study.component
            {...modules.study}
            type="component"
            name="home-study"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <modules.workspace.component
            {...modules.workspace}
            type="component"
            name="home-workspace"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <modules.library.component
            {...modules.study}
            type="component"
            name="home-widget"
            config={{}}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <modules.datacatalog.component
            {...modules.workspace}
            type="component"
            name="home-widget"
            config={{}}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <modules.documentation.component
            {...modules.documentation}
            type="component"
            name="home-widget"
            config={{}}
          />
        </Grid>
        {IS_ADMIN && (
          <Grid item xs={12} md={6}>
            <modules.admin.component
              {...modules.workspace}
              type="component"
              name="home-widget"
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
